module.exports = __webpack_public_path__ + "img/aramzamzam.cb6e4d74.png";